var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSubjectComm = function SvgIconSubjectComm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-subj-comm",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-405.411 -84.104)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pages"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    transform: "translate(407.411 89.104)",
    fill: "#ebebeb",
    d: "M0 0h13v14H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M416.411 99.1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2Z",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M416.411 95.1h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2Z",
    fill: "#a0a0a0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "chat"
  }, /*#__PURE__*/React.createElement("path", {
    id: "chat-2",
    "data-name": "chat",
    d: "M421.661 85.1h-2.5a3.749 3.749 0 0 0-.833 7.4v2.6l2.917-2.5h.416a3.75 3.75 0 0 0 0-7.5Z",
    fill: "#1eaae1"
  })))));
};
export { SvgIconSubjectComm as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iaWNvbi1zdWJqLWNvbW0iIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIiB2aWV3Qm94PSIwIDAgMjAgMjAiPgogICAgPHJlY3QgaWQ9ImFyZWEiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgZmlsbD0iI2YyZjJmMiIgb3BhY2l0eT0iMCIvPgogICAgPGcgaWQ9Imljb24iIHRyYW5zZm9ybT0idHJhbnNsYXRlKDIgMSkiPgogICAgICAgIDxnIGlkPSJwYWdlcyIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTQwNy40MTEgLTg1LjEwNCkiPgogICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlXzciIGRhdGEtbmFtZT0iUmVjdGFuZ2xlIDciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxNCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDA3LjQxMSA4OS4xMDQpIgogICAgICAgICAgICAgICAgICBmaWxsPSIjZWJlYmViIi8+CiAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoXzY4IiBkYXRhLW5hbWU9IlBhdGggNjgiIGQ9Ik00MTYuNDExLDk5LjFoLTVhMSwxLDAsMCwxLDAtMmg1YTEsMSwwLDAsMSwwLDJaIiBmaWxsPSIjYTBhMGEwIi8+CiAgICAgICAgICAgIDxwYXRoIGlkPSJQYXRoXzY5IiBkYXRhLW5hbWU9IlBhdGggNjkiIGQ9Ik00MTYuNDExLDk1LjFoLTVhMSwxLDAsMCwxLDAtMmg1YTEsMSwwLDAsMSwwLDJaIiBmaWxsPSIjYTBhMGEwIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIGlkPSJjaGF0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNDA3LjQxMSAtODUuMTA0KSI+CiAgICAgICAgICAgIDxwYXRoIGlkPSJjaGF0LTIiIGRhdGEtbmFtZT0iY2hhdCIKICAgICAgICAgICAgICAgICAgZD0iTTQyMS42NjEsODUuMWgtMi41YTMuNzQ5LDMuNzQ5LDAsMCwwLS44MzMsNy40djIuNmwyLjkxNy0yLjVoLjQxNmEzLjc1LDMuNzUsMCwwLDAsMC03LjVaIgogICAgICAgICAgICAgICAgICBmaWxsPSIjMWVhYWUxIi8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";